module.exports = __webpack_public_path__ + "static/media/Coffee_.60cdfc26.png";